// import React, { useState } from "react";
// import Cart from "../../Assets/cart.png";
// import "./cartButton.css";
// import { useSelector } from "react-redux";
// import { Link, useLocation, useParams } from "react-router-dom";
// import { pathUpdateWithExtention } from "../../Utills/utils";
// import { toast } from "react-toastify";

// // 🌟 Props mein tableName ko accept kiya
// const CartButton = ({ tableName: propsTableName }) => {
//   const fullCartState = useSelector((state) => state?.user?.cart);
//   const [msg, setMsg] = useState("");
//   const location = useLocation();
//   const { tableName: urlTableName } = useParams();

//   // Props se tableName check karein, agar na mile toh URL params se backup lein
//   const tableName = propsTableName || urlTableName || "DIRECT_BILL";

//   // Sirf current active table ka cart object nikaalein
//   const tableCart = fullCartState?.[tableName] || {};

//   // 🌟 FIXED: Ab count poore global state ka nahi, balki sirf is specific table ke items ka sum hoga
//   const count = Object.values(tableCart).reduce((total, item) => {
//     return total + (item?.selected || 0);
//   }, 0);

//   let linkTo = "";
//   if (count !== 0) {
//     if (location.pathname.includes("table")) {
//       linkTo = `${location.pathname}/cart`;
//     } else if (location.pathname.includes("menu")) {
//       linkTo = pathUpdateWithExtention("bill");
//     }
//   }

//   return (
//     <div className="cartContainer">
//       {linkTo ? (
//         <Link
//           to={linkTo}
//           onClick={() => {
//             if (count === 0) toast.warning("No item Selected please select items");
//           }}
//         >
//           <div className="iconContainer">
//             <img src={Cart} alt="Cart Icon" className="cartIcon" />
//             <div className="count">{count}</div>
//           </div>
//         </Link>
//       ) : (
//         <div
//           className="iconContainer"
//           onClick={() => toast.warning("No item Selected please select items")}
//         >
//           <img src={Cart} alt="Cart Icon" className="cartIcon" />
//           <div className="count">{count}</div>
//         </div>
//       )}

//       {msg && <div className="errorMsg">{msg}</div>}
//     </div>
//   );
// };

// export default CartButton;


import React, { useState } from "react";
import Cart from "../../Assets/cart.png";
import "./cartButton.css";
import { useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { pathUpdateWithExtention } from "../../Utills/utils";
import { toast } from "../../Utills/toast";

// Props mein tableName ko accept kiya
const CartButton = ({ tableName: propsTableName }) => {
  const fullCartState = useSelector((state) => state?.user?.cart);
  const [msg, setMsg] = useState("");
  const location = useLocation();
  const { tableName: urlTableName } = useParams();

  // Extract location.state to check for active billTaxDetails (e.g., when resuming a draft)
  const navState = location.state || {};

  // Props se tableName check karein, agar na mile toh URL params se backup lein
  const tableName = propsTableName || urlTableName || "DIRECT_BILL";
  // Sirf current active table ka cart object nikaalein
  const tableCart = fullCartState?.[tableName] || {};
  // Count poore global state ka nahi, balki sirf is specific table ke items ka sum hoga
  const count = Object.values(tableCart).reduce((total, item) => {
    return total + (item?.selected || 0);
  }, 0);

  let linkTo = "";
  if (count !== 0) {
    if (location.pathname.includes("table")) {
      linkTo = `${location.pathname}/cart`;
    } else if (location.pathname.includes("menu")) {
      linkTo = pathUpdateWithExtention("bill");
    }
  }

  return (
    <div className="cartContainer">
      {linkTo ? (
        <Link
          to={linkTo}
          className="cartDesktopAction"
        //  state={navState} // 👈 FORWARD LOCATION STATE (contains billTaxDetails)
          onClick={() => {
            if (count === 0) toast.warning("Please select at least one item.");
          }}
        >
          <div className="iconContainer">
            <img src={Cart} alt="Cart Icon" className="cartIcon" />
            <div className="count">{count}</div>
          </div>
        </Link>
      ) : (
        <div
          className="iconContainer cartDesktopAction"
          onClick={() => toast.warning("Please select at least one item.")}
        >
          <img src={Cart} alt="Cart Icon" className="cartIcon" />
          <div className="count">{count}</div>
        </div>
      )}

      {linkTo ? (
        <Link to={linkTo} className="cartMobileBillButton">
          <span>Generate Bill</span>
          <strong>{count}</strong>
        </Link>
      ) : (
        <button
          type="button"
          className="cartMobileBillButton is-disabled"
          onClick={() => toast.warning("Please select at least one item.")}
        >
          <span>Generate Bill</span>
          <strong>{count}</strong>
        </button>
      )}

      {msg && <div className="errorMsg">{msg}</div>}
    </div>
  );
};

export default CartButton;


